import React from "react";
import { useI18n } from "@/i18n";
import { useReveal } from "@/hooks/useReveal";
import RevealOnView from "@/components/site/RevealOnView";

export default function HowItWorks() {
  const { t } = useI18n();
  const header = useReveal();

  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative py-24 md:py-36 border-t border-neutral-200"
    >
      <div className="max-w-[1240px] mx-auto px-5 md:px-8">
        <div
          ref={header.ref}
          className={`reveal ${header.visible ? "is-visible" : ""} max-w-3xl`}
        >
          <div className="text-[11px] tracking-[0.24em] uppercase text-neutral-500 mb-5">
            <span
              className="inline-block w-6 h-px align-middle mr-3"
              style={{ background: "#c9a86a" }}
            />
            {t.how.eyebrow}
          </div>
          <h2
            data-testid="how-title"
            className="font-display text-[34px] sm:text-[44px] md:text-[56px] leading-[1.05] tracking-[-0.02em] font-light text-neutral-950"
          >
            {t.how.title}
          </h2>
          <p className="mt-5 text-neutral-600 text-[15px] md:text-[17px] max-w-xl leading-relaxed">
            {t.how.sub}
          </p>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {t.how.steps.map((step, i) => (
            <RevealOnView
              key={step.number}
              delay={Math.min(i + 1, 5)}
              data-testid={`how-step-${i + 1}`}
              className="group relative"
            >
              <div className="flex items-baseline gap-4">
                <span
                  className="font-display wf-tabular text-[52px] md:text-[72px] font-light text-neutral-200 group-hover:text-[color:var(--wf-gold)] transition-colors duration-500"
                  style={{ letterSpacing: "-0.04em" }}
                >
                  {step.number}
                </span>
                <span
                  aria-hidden
                  className="flex-1 h-px bg-neutral-200 relative overflow-hidden"
                >
                  <span
                    className="absolute left-0 top-0 h-full w-0 group-hover:w-full transition-[width] duration-700"
                    style={{ background: "#c9a86a" }}
                  />
                </span>
              </div>
              <h3 className="mt-6 font-display text-[22px] md:text-[26px] tracking-[-0.01em] font-medium text-neutral-950">
                {step.title}
              </h3>
              <p className="mt-3 text-neutral-600 leading-relaxed">
                {step.body}
              </p>
            </RevealOnView>
          ))}
        </div>

        {/* Wide editorial image */}
        <div className="mt-16 md:mt-24">
          <div
            data-testid="how-image-wrap"
            className="relative overflow-hidden rounded-[12px] border border-neutral-200 aspect-[16/7]"
          >
            <img
              src="https://images.unsplash.com/photo-1764380748052-640fc0593e4d"
              alt="Un'invitata scatta foto alla sposa"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div
              aria-hidden
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(180deg, rgba(10,10,10,0.0) 60%, rgba(10,10,10,0.25) 100%)",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
